// src/pages/NotFoundPage.tsx
import React from 'react';
import { Box, Button, Container, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Home } from '@mui/icons-material';

const NotFoundPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Container 
      maxWidth="xl" 
      sx={{ 
        py: 4, 
        minHeight: '80vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}
    >
      <Box 
        sx={{ 
          textAlign: 'center', 
          maxWidth: 600,
          p: 4,
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          bgcolor: 'white'
        }}
      >
        <Typography 
          variant="h1" 
          fontWeight={800} 
          sx={{ 
            fontSize: { xs: '4rem', md: '6rem' },
            color: '#C4B08C',
            mb: 2
          }}
        >
          404
        </Typography>
        
        <Typography 
          variant="h4" 
          fontWeight={700} 
          sx={{ 
            mb: 2,
            color: theme.palette.text.primary
          }}
        >
          Page Not Found
        </Typography>
        
        <Typography 
          variant="body1" 
          sx={{ 
            mb: 4,
            color: theme.palette.text.secondary,
            fontSize: '1.1rem'
          }}
        >
          Oops! The page you're looking for doesn't exist or has been moved.
        </Typography>
        
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          startIcon={<Home />}
          sx={{
            bgcolor: '#C4B08C',
            color: '#000',
            '&:hover': { bgcolor: '#b39d77' },
            px: 4,
            py: 1.5,
            borderRadius: 2,
            fontSize: '1rem',
            fontWeight: 600
          }}
        >
          Back to Home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFoundPage;